import "rc-segmented/assets/index.css";
import React from "react";
import "./project-definition-color-picker.scss";

export interface IState {}

export interface IProps {
  iconColor: string;
  onChange: (color: string) => void;
  type: "iconColor" | "backgroundColor";
}

// Native <input type="color"> needs a full 6-digit hex; expand shorthand like #FFF.
const normalizeHex = (color: string): string => {
  if (!color) return "#000000";
  let hex: string = color.startsWith("#") ? color.substring(1) : color;
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((ch: string) => ch + ch)
      .join("");
  }
  return `#${hex}`;
};

class ProjectDefinitionColorPicker extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  render() {
    const hexValue: string = this.props.iconColor?.startsWith("#")
      ? this.props.iconColor.substring(1)
      : this.props.iconColor;
    return (
      <div className="kuika-color-input">
        <input
          type="color"
          data-testid={`${this.props.type}Swatch`}
          className="kuika-color-input__swatch"
          value={normalizeHex(this.props.iconColor)}
          onChange={(e) => this.props.onChange(e.target.value)}
        />
        <span className="kuika-color-input__hash">#</span>
        <input
          data-testid={`${this.props.type}Hex`}
          className="kuika-color-input__hex"
          value={hexValue}
          onChange={(e) => this.props.onChange(`#${e.target.value?.toUpperCase()}`)}
        />
        <span className="kuika-color-input__suffix">HEX</span>
      </div>
    );
  }
}
export default ProjectDefinitionColorPicker;
